import {Component, Input, OnInit} from '@angular/core';
import {AppContext} from "../../../../app-context";
import {RefdataUtils} from "../../refdata-utils";
import {Category, MeterDetails, MeterType, Tag, UpdateMeterDetails} from "@flowmaps/flowmaps-typescriptmodels";
import {SentenceCasePipe} from "../../../../common/sentence-case.pipe";
import {View} from "../../../../common/view";
import {Handler} from "../../../../common/handler";
import {Entity} from "../../../../handlers/entity";
import {cloneDeep} from "lodash";
import {trackByIndex} from "../../../../common/utils";

@Component({
    selector: 'app-meter-details',
    templateUrl: './meter-details.component.html',
    styleUrls: ['./meter-details.component.scss']
})
@Handler()
export class MeterDetailsComponent extends View implements OnInit {
    appContext = AppContext;
    refDataUtils = RefdataUtils;
    details: MeterDetails;
    @Input() data: MeterComponentData;
    meterTypes: MeterType[] = [MeterType.PRIMARY, MeterType.INTERMEDIATE, MeterType.GROSS_PRODUCTION];
    categories: Category[] = [Category.floor, Category.tower, Category.department, Category.custom];
    newTags: Tag[] = [];

    protected readonly trackByIndex = trackByIndex;
    meterTypeFormatter = (v: string): string => SentenceCasePipe.format(v);

    ngOnInit(): void {
        this.details = cloneDeep(this.data.entity.meter.details) || cloneDeep(this.data.entity.meter.info);
        if (!this.details.meterNumbers || this.details.meterNumbers.length === 0) {
            this.details.meterNumbers = [''];
        }
        if (!this.details.tags) {
            this.details.tags = [];
        }
    }

    addTag() {
        this.newTags.push({
            category: null,
            value: '',
            customType: ''
        });
    }

    removeTag(array: Tag[], index: number) {
        array.splice(index, 1);
    }

    onCategoryChange(tag: Tag) {
        if (tag.category !== Category.custom) {
            tag.customType = '';
        }
    }

    updateInfo = () => {
        const validNewTags = this.newTags.filter(t => t.category && t.value);
        this.details = {
            ...this.details,
            tags: [...this.details.tags, ...validNewTags]
        };
        this.sendCommand("com.flowmaps.api.organisation.UpdateMeterDetails", <UpdateMeterDetails>{
            organisationId: this.data.entity.organisation.organisationId,
            locationId: this.data.entity.location.locationId,
            meterId: this.data.entity.meter.meterId,
            connectionId: this.data.entity.connection.connectionId,
            details: this.details
        });
        this.newTags = [];
    };
}

export interface MeterComponentData {
    entity: Entity;
}